import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { SupplierDto } from "./supplier.dto";
import { UpdateSupplierDto } from "./update-supplier.dto";
import { CreateSupplierDto } from "./create-supplier.dto";
import { IRequest } from "@/interfaces/IRequest";
import { OptionType } from "@/types/OptionType";
import { merge } from "lodash";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class SupplierResource extends ResourceBaseService<SupplierDto, CreateSupplierDto, UpdateSupplierDto> {
  protected EntityDto = SupplierDto;
  protected CreateEntityDto = CreateSupplierDto;
  protected UpdateEntityDto = UpdateSupplierDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/suppliers");
  }

  async optionLoader(inputValue: string, customRequest?: IRequest): Promise<OptionType[]> {
    const request: IRequest = inputValue
      ? { search: inputValue, searchBy: ["id", "code", "name", "businessName", "vatNumber"] }
      : {};
    request.sortBy = "code";
    if (customRequest) merge(request, customRequest);
    const { data } = await this.findAll(applyOptionLoaderPagination(request));

    return data.map((value) => value.mapEntityToOptionType([value.code, "-", value.name]));
  }
}
